import { isNodeVisible } from './isNodeVisible';

// with assumption that particular node is inside parent nested directly in PageNode
export const shallowFind = (nodeId: string) => {
  for (const child of figma.currentPage.children) {
    if (isNodeVisible(child) && 'children' in child) {
      for (const subChild of child.children) {
        if (subChild.id === nodeId) return subChild;
      }
    }
  }

  return null;
};

export const shallowFindInContainer = (nodeId: string, container: BaseNode) => {
  if (!('children' in container)) return null;

  return container.children.find((child) => child.id === nodeId) || null;
};

export const shallowFindByNameInContainer = (
  nodeName: string,
  container: BaseNode
) => {
  if (!('children' in container)) return null;

  return container.children.find((child) => child.name === nodeName) || null;
};
